<template>
  <div class="snackbarContainer"></div>
  <!-- <v-snackbar
    bottom
    class="pa-2"
    :color="color"
    @input="close"
    left
    shaped
    :timeout="timeout"
    :value="visible"
    :vertical="vertical"
  >
    <span>{{ message }}</span>
    <template v-slot:action="{ attrs }">
      <v-btn rounded class="mr-1" icon :color="buttonColor" text v-bind="attrs" @click="close">
        <v-icon>close</v-icon>
      </v-btn>
    </template>
  </v-snackbar> -->
</template>

<script>
export default {
  computed: {
    buttonColor() {
      return this.snackbar?.buttonColor
    },
    color() {
      return this.snackbar?.color
    },
    message() {
      return this.snackbar?.message
    },
    snackbar() {
      return this.$store.getters['core/snackbar']
    },
    timeout() {
      return this.snackbar?.timeout
    },
    vertical() {
      return this.snackbar?.vertical
    },
    visible() {
      return this.snackbar?.visible
    },
  },
  methods: {
    close() {
      this.$store.dispatch('core/closeSnackbar')
    },
  },
}
</script>
